export default __webpack_public_path__ + "static/media/038-mine.987082cb.svg";